import { Component, Input, OnInit, AfterViewInit, ViewChild, OnDestroy } from '@angular/core';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { Location } from '@angular/common';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { ScrollPanel } from 'primeng/scrollpanel';
import { AppComponent } from './app.component';
// import { NgxSpinnerService } from 'ngx-spinner';
import * as _ from 'underscore';
import { filter } from 'rxjs/operators';
import { Subscription } from 'rxjs';
import { MenuItem } from 'primeng/api';

@Component({
    selector: 'app-menu',
    templateUrl: './app.menu.component.html',
    providers: []
})
export class AppMenuComponent implements OnInit, AfterViewInit {
    @Input() reset: boolean;
    model: any[];
    model1: any[];
    userRole: string;
    firstName: string;
    lastName: string;
    email: string;
    apikey: string;
    role_FLXT: any;
    role_APPL: any;
    role_ANLT: any;
    private role_UMT: any;
    private subRole_VMT: any;
    private subRole_VAV: any;
    subAppList;
    private displayId: any;
    appName: any = "";
    private appId: any = "";
    groupName: any = "";
    private groupId: any = "";
    private dataList: any;
    private practiceSetList: any;
    PracticeSetName: any = "";
    private PracticeSetId: any = "";
    private isGroup: boolean = false;
    private isPractice: boolean = false;
    private isTable: boolean = false;
    @ViewChild('layoutMenuScroller', { static: false }) layoutMenuScrollerViewChild: ScrollPanel;

    constructor(public app: AppComponent, private router: Router) {
        this.subAppList = JSON.parse(JSON.stringify(localStorage.getItem("subApps")));
    }

    ngOnInit() {
    }

    ngAfterViewInit() {
        setTimeout(() => { this.layoutMenuScrollerViewChild.moveBar(); }, 100);
    }

    changeTheme(theme) {
        const themeLink: HTMLLinkElement = <HTMLLinkElement>document.getElementById('theme-css');
        themeLink.href = 'assets/theme/theme-' + theme + '.css';
    }

    changeLayout(layout) {
        const layoutLink: HTMLLinkElement = <HTMLLinkElement>document.getElementById('layout-css');
        layoutLink.href = 'assets/layout/css/layout-' + layout + '.css';
    }

    onMenuClick() {
        if (!this.app.isHorizontal()) {
            setTimeout(() => {
                this.layoutMenuScrollerViewChild.moveBar();
            }, 450);
        }

        // this.app.onMenuClick();
    }

    public goToApp(appCode) {
        if (appCode == "VMT") {
            this.router.navigate(['/airport']);
        }
        else if (appCode == "VAV") {
            this.router.navigate(['/Vis/vis']);
        }
    }

    selectApp() {
        if (!_.isUndefined(this.subAppList)) {
            _.each(this.subAppList, (obj) => {
                let dataObj: any = obj;
                if (dataObj.permission_desc === this.appName)
                    dataObj.classFlag = true;
                else
                    dataObj.classFlag = false;
            });
        }
    }

    // public getGroup() {
    //     this.contentManagementService.getGroup(this.appId).subscribe(data => {
    //             let dataObject: any = data;
    //             let jsonParse: any = dataObject;
    //             this.displayId = jsonParse.appsBaseFacilitiesTableId;
    //             if (dataObject != "") {
    //                 this.dataList = jsonParse.listofPracticeGroupIds;
    //                 let updatedDataList: any = [];
    //                 updatedDataList = _.clone(this.dataList);
    //                 _.each(updatedDataList, (obj) => {
    //                     let dataObj: any = obj;
    //                     let tokens: any = [];
    //                     tokens = dataObj.practiceGroupName.split('-');
    //                     if (!_.isUndefined(tokens))
    //                         dataObj.practiceGroupName = (tokens[tokens.length - 1]);
    //                 })
    //                 this.groupVariableSetting();
    //             } else {
    //                 this.dataList = [];
    //                 this.groupVariableSetting();
    //             }
    //     })
    // }

    public groupVariableSetting() {
        this.practiceSetList = [];
        this.groupId = "";
        this.groupName = "";
        this.PracticeSetName = "";
        this.PracticeSetId = "";
        this.isGroup = true;
        this.isPractice = false;
        this.isTable = false;
    }

}

@Component({
    selector: '[app-submenu]',
    template: `
        <ng-template ngFor let-child let-i="index" [ngForOf]="(root ? item : item.items)">
            <li [ngClass]="{'active-menuitem': app.menuActiveIndex == i}">
                <a [href]="child.url||'#'" (click)="itemClick($event,child,i)" *ngIf="!child.routerLink"
                   [attr.tabindex]="!visible ? '-1' : null" [attr.target]="child.target" (mouseenter)="onMouseEnter(i)">
                    <i [ngClass]="child.icon"></i>
                    <span>{{child.label}}</span>
                    <i class="fa fa-fw fa-angle-down layout-submenu-toggler" *ngIf="child.items"></i>
                    <span class="menuitem-badge" *ngIf="child.badge" [ngClass]="child.badgeStyleClass">{{child.badge}}</span>
                </a>

                <a (click)="itemClick($event,child,i)" *ngIf="child.routerLink"
                     [attr.tabindex]="!visible ? '-1' : null" [attr.target]="child.target"
                     [routerLink]="child.routerLink"
                    (mouseenter)="onMouseEnter(i)">
                    <i [ngClass]="child.icon"></i>
                    <span>{{child.label}}</span>
                    <i class="fa fa-fw fa-angle-down" *ngIf="child.items"></i>
                    <span class="menuitem-badge" *ngIf="child.badge" [ngClass]="child.badgeStyleClass">{{child.badge}}</span>
                </a>
            </li>
        </ng-template>
    `,
    animations: [
        trigger('children', [
            state('visible', style({
                height: '*'
            })),
            state('hidden', style({
                height: '0px'
            })),
            transition('visible => hidden', animate('400ms cubic-bezier(0.86, 0, 0.07, 1)')),
            transition('hidden => visible', animate('400ms cubic-bezier(0.86, 0, 0.07, 1)'))
        ])
    ]
})
export class AppSubMenuComponent implements AfterViewInit, OnDestroy {

    @Input() item: MenuItem;
    @Input() root: boolean;
    @Input() visible: boolean;
    _reset: boolean;
    _parentActive: boolean;
    activeIndex: number;
    hover: boolean;
    subSink: Subscription;
    private appName: any = "";
    private appId: any = "";

    constructor(public app: AppComponent, private route: ActivatedRoute, public router: Router, public location: Location, public appMenu: AppMenuComponent) {
    }

    itemClick(event: Event, item: MenuItem, index: number) {
        this.app.menuActiveIndex = index;
        // ((app.activeAppLibMenu && child.label=='App Library') || (app.activeAnalyticsMenu && child.label=='Analytics') || (app.activeContentManagementMenu && child.label=='Content Management'))
        // routerLinkActive="active-menuitem-routerlink"
        // [routerLink]="child.routerLink"
        // [routerLinkActiveOptions]="{exact: true}"
        if (this.root) {
            this.app.menuHoverActive = !this.app.menuHoverActive;
        }

        // avoid processing disabled items
        if (item.disabled) {
            event.preventDefault();
            return true;
        }

        // activate current item and deactivate active sibling if any
        if (item.routerLink || item.items || item.command || item.url) {
            this.activeIndex = (this.activeIndex === index) ? null : index;
        }

        // execute command
        if (item.command) {
            item.command({ originalEvent: event, item: item });
        }

        // prevent hash change
        if (item.items || (!item.url && !item.routerLink)) {
            setTimeout(() => {
                this.appMenu.layoutMenuScrollerViewChild.moveBar();
            }, 450);
            event.preventDefault();
        }

        // hide menu
        if (!item.items) {
            if (this.app.menuMode === 'horizontal') {
                this.app.resetMenu = true;
            } else {
                this.app.resetMenu = false;
            }
            if (this.app.isMobile() || this.app.menuMode === 'overlay' || this.app.menuMode === 'popup') {
                this.app.menuActive = false;
            }

            this.app.menuHoverActive = false;
        }
        this.app.onMenuClick(item.label);
    }

    onMouseEnter(index: number) {
        if (this.root && this.app.menuHoverActive && this.app.isHorizontal()
            && !this.app.isMobile() && !this.app.isTablet()) {
            this.activeIndex = index;
        }
    }

    isActive(index: number): boolean {

        return this.activeIndex === index;
    }

    @Input() get reset(): boolean {
        return this._reset;
    }

    set reset(val: boolean) {
        this._reset = val;

        if (this._reset && (this.app.menuMode === 'horizontal')) {
            this.activeIndex = null;
        }
    }

    @Input() get parentActive(): boolean {
        return this._parentActive;
    }

    set parentActive(val: boolean) {
        this._parentActive = val;

        if (!this._parentActive) {
            this.activeIndex = null;
        }
    }
    ngAfterViewInit() {
        // (this.root ? this.item : this.item.items).filter( item => item.)

        this.subSink = this.router.events.pipe(filter(event => event instanceof NavigationEnd))
        .subscribe((event: NavigationEnd) => {
            let rt = [this.route.snapshot];
            while (rt['0'].firstChild) {
                rt['0'] = rt['0'].firstChild;
            }
            const data = (this.root ? this.item : this.item.items);
            if (data && rt['0'].data.name) {
                (data as any[]).map( (item, index) => {
                    if (item.label === rt['0'].data.name) {
                        this.app.menuActiveIndex = index;
                    }
                });
            }
        })
    }

    ngOnDestroy() {
        if(this.subSink)
        this.subSink.unsubscribe();
    }
}
